module.exports = __webpack_public_path__ + "e7a09daf4626bb837d00d5551c588ba0.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/home-1.svg
// module id = 481
// module chunks = 0